import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import React from 'react';
import { iconsvgRaw } from './iconsvg';
import Icon from '@ant-design/icons';
const IconDownload = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={iconsvgRaw.icondownload} {...props} />
);
const IconAddData = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={iconsvgRaw.iconAddData} {...props} />
);
const IconActionsTable = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={iconsvgRaw.iconActionsTable} {...props} />
);
const IconUser = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={iconsvgRaw.iconuser} {...props} />
);
const IconPassword = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={iconsvgRaw.iconpassword} {...props} />
);
const IconLogOut = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={iconsvgRaw.iconLogOut} {...props} />
);
const IconCouponCode = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={iconsvgRaw.iconCouponCode} {...props} />
);
const IconError = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={iconsvgRaw.iconError} {...props} />
);
const IconSuccess = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={iconsvgRaw.iconSuccess} {...props} />
);
export const Iconsvg = {
  IconDownload,
  IconAddData,
  IconActionsTable,
  IconPassword,
  IconUser,
  IconLogOut,
  IconCouponCode,
  IconError,
  IconSuccess,
};
